import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.7452 4.25444C15.9892 4.49852 15.9892 4.89425 15.7452 5.13833L5.13856 15.7449C4.89449 15.989 4.49876 15.989 4.25468 15.7449C4.0106 15.5008 4.0106 15.1051 4.25468 14.861L14.8613 4.25444C15.1054 4.01036 15.5011 4.01036 15.7452 4.25444Z'
            fill={color}
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4.25469 4.25435C4.49876 4.01027 4.89449 4.01027 5.13857 4.25435L15.7452 14.8609C15.9892 15.105 15.9892 15.5008 15.7452 15.7448C15.5011 15.9889 15.1054 15.9889 14.8613 15.7448L4.25469 5.13823C4.01061 4.89415 4.01061 4.49843 4.25469 4.25435Z'
            fill={color}
        />
    </>
)

export const Xcross: React.FC<IconProps> = ({ color, size }) => (
    <IconWrapper {...{ size, color, renderIcon }} viewBox={'0 0 20 20'} />
)
